import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useParams, useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import axios from "axios";
import "./details.css";
import { IconCoinRupee } from "@tabler/icons-react";
import { ArrowBackIos } from "@mui/icons-material";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function DetailsofEmp() {
  const [value, setValue] = useState(0);
  const [employeeData, setEmployeeData] = useState(null);
  const { id: employeeId } = useParams();
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleNavigation = () => {
    navigate(`/user/salaryslip/${employeeId}`);
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/account/users-list/${employeeId}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setEmployeeData(response.data);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    if (employeeId) {
      fetchEmployeeData();
    }
  }, [employeeId]);

  const personalDetails = [
    { label: "Name", value: employeeData?.name || "N/A" },
    { label: "Gender", value: employeeData?.gender || "N/A" },
    { label: "Nationality", value: employeeData?.nationality || "N/A" },
    { label: "Blood Group", value: employeeData?.blood_group || "N/A" },
    { label: "Marital Status", value: employeeData?.marital_status || "N/A" },
    { label: "Educational Level", value: employeeData?.education_level || "N/A" },
  ];

  const jobDetails = [
    { label: "Job Position", value: employeeData?.job_position?.job_title || "N/A" },
    { label: "Employee Type", value: employeeData?.employee_type || "N/A" },
    { label: "Job Type", value: employeeData?.job_type?.job_type || "N/A" },
    { label: "Department", value: employeeData?.department?.dep_name || "N/A" },
    { label: "Branch", value: employeeData?.branch?.branch_name || "N/A" },
    { label: "Experience", value: employeeData?.work_experience || "N/A" },
    { label: "Joining Date", value: employeeData?.joined_date || "N/A" },
    { label: "End of Probation", value: employeeData?.end_of_probation || "N/A" },
    { label: "Effective Date", value: employeeData?.effective_date || "N/A" },
    { label: "Basic Salary", value: employeeData?.basic_salary || "N/A" },
    { label: "Salary Type", value: employeeData?.type_of_salary?.type_of_salary || "N/A" },
    { label: "Currency", value: employeeData?.currency || "N/A" },
    { label: "Benefits", value: employeeData?.benifits || "N/A" },
    { label: "Bonus", value: employeeData?.bonus || "N/A" },
    { label: "Deduction", value: employeeData?.deduction || "N/A" },
    { label: "Reporting To", value: employeeData?.reporting_to?.[0]?.name || "N/A" },
    { label: "HR To", value: employeeData?.hr_to?.[0]?.name || "N/A" },
  ];

  const contactDetails = [
    { label: "Email", value: employeeData?.email || "N/A" },
    { label: "Phone Number", value: employeeData?.phone_number || "N/A" },
    { label: "Office Phone", value: employeeData?.office_phone || "N/A" },
    { label: "Address", value: `${employeeData?.address_1 || ""} ${employeeData?.address_2 || ""}`.trim() || "N/A" },
    { label: "City", value: employeeData?.city || "N/A" },
    { label: "State", value: employeeData?.state || "N/A" },
    { label: "Pincode", value: employeeData?.pincode || "N/A" },
    { label: "Relative Name", value: employeeData?.relative_name || "N/A" },
    { label: "Relation", value: employeeData?.relation || "N/A" },
    { label: "Relative Phone", value: employeeData?.rel_phone_number || "N/A" },
  ];

  const bankDetails = employeeData?.bank_details?.length > 0 ? [
    { label: "Account Holder", value: employeeData.bank_details[0].account_holder_name || "N/A" },
    { label: "Account Number", value: employeeData.bank_details[0].account_number || "N/A" },
    { label: "IFSC Code", value: employeeData.bank_details[0].ifsc_code || "N/A" },
    { label: "Bank Name", value: employeeData.bank_details[0].bank_name || "N/A" },
    { label: "Branch Name", value: employeeData.bank_details[0].branch_name || "N/A" },
  ] : [{ label: "Bank Details", value: "No details available" }];

  const documentLabels = {
    passportPhoto: "Passport Photo",
    sslc: "SSLC Certificate",
    adhar: "Aadhar Card",
    pancard: "PAN Card",
  };

  const documents = employeeData?.documents?.length > 0 ? employeeData.documents.map(doc => ({
    label: documentLabels[doc.document_type] || doc.document_type,
    value: doc.file ? (
      <a
        href={doc.file}
        target="_blank"
        rel="noopener noreferrer"
        className="document-link"
      >
        <i className="bi bi-file-earmark-pdf"></i> View Document
      </a>
    ) : "N/A"
  })) : [{ label: "Documents", value: "No documents available" }];

  return (
    <div className="DetailsContainer">
      <div className="profileInfo">
        <div className="back-btn-wrapper w-100">
          <button onClick={() => navigate(-1)} className="back-btn-custom">
            <ArrowBackIos sx={{ fontSize: 14 }} /> Back
          </button>
        </div>

        <div className="imgContainer">
          <img
            src={employeeData?.profile_photo || "/assets/user.png"}
            alt="profile"
            style={{ border: employeeData?.status ? '4px solid #15803D' : '4px solid #B91C1C' }}
          />
        </div>

        <h6 className="emp-name">{employeeData?.name || "N/A"}</h6>

        <span className={`status-badge ${employeeData?.status ? 'status-active' : 'status-inactive'}`}>
          {employeeData?.status ? "Active" : "Inactive"}
        </span>

        <div className="profileDatas">
          <div className="info-item">
            <div className="info-icon-box"><i className="bi bi-hash"></i></div>
            <div className="info-text-box">
              <p>Employee Code</p>
              <h6>P{employeeData?.employee_code || "N/A"}</h6>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon-box"><i className="bi bi-briefcase"></i></div>
            <div className="info-text-box">
              <p>Position</p>
              <h6>{employeeData?.job_position?.job_title || "N/A"}</h6>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon-box"><i className="bi bi-envelope"></i></div>
            <div className="info-text-box">
              <p>Email</p>
              <h6>{employeeData?.email || "N/A"}</h6>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon-box"><i className="bi bi-geo-alt"></i></div>
            <div className="info-text-box">
              <p>Location</p>
              <h6>{employeeData?.city || "N/A"}</h6>
            </div>
          </div>
        </div>
      </div>

      <div className="mainDetails">
        <div className="action-bar">
          <div className="page-title">
            <h4 className="fw-bold mb-0" style={{ color: 'var(--text-main)' }}>Employee Profile</h4>
            <p className="text-muted small mb-0">Detailed view of personnel records and credentials</p>
          </div>
          <button className="btn salary-btn" onClick={handleNavigation}>
            <IconCoinRupee stroke={2} size={20} /> Show Salary Slip
          </button>
        </div>

        <Box className="custom-tabs-box">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="employee details tabs"
          >
            <Tab label="Personal" {...a11yProps(0)} />
            <Tab label="Job Details" {...a11yProps(1)} />
            <Tab label="Contact" {...a11yProps(2)} />
            <Tab label="Bank Info" {...a11yProps(3)} />
            <Tab label="Documents" {...a11yProps(4)} />
          </Tabs>

          <CustomTabPanel value={value} index={0}>
            <div className="details-grid">
              {personalDetails.map((detail, index) => (
                <div key={index} className="info-card">
                  <p className="card-label">{detail.label}</p>
                  <h6 className="card-value">{detail.value}</h6>
                </div>
              ))}
            </div>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={1}>
            <div className="details-grid">
              {jobDetails.map((detail, index) => (
                <div key={index} className="info-card">
                  <p className="card-label">{detail.label}</p>
                  <h6 className="card-value">{detail.value}</h6>
                </div>
              ))}
            </div>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={2}>
            <div className="details-grid">
              {contactDetails.map((detail, index) => (
                <div key={index} className="info-card">
                  <p className="card-label">{detail.label}</p>
                  <h6 className="card-value">{detail.value}</h6>
                </div>
              ))}
            </div>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={3}>
            <div className="details-grid">
              {bankDetails.map((detail, index) => (
                <div key={index} className="info-card">
                  <p className="card-label">{detail.label}</p>
                  <h6 className="card-value">{detail.value}</h6>
                </div>
              ))}
            </div>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={4}>
            <div className="details-grid">
              {documents.map((doc, index) => (
                <div key={index} className="info-card">
                  <p className="card-label">{doc.label}</p>
                  <h6 className="card-value">{doc.value}</h6>
                </div>
              ))}
            </div>
          </CustomTabPanel>
        </Box>
      </div>
    </div>
  );
}